import { Button, Card, CardBody } from "reactstrap"
import { useNavigate } from "react-router-dom"
import MoneyReceiptList from "pages/CustomerPages/CustomerProfile/MoneyReceipt/MoneyReceiptList"
import { CanView } from "components/Common/CanView"
import { ACCESS } from "constants/accessPermissions"

export default function MoneyReceiptsTab({ stock, onChanged }) {
  const navigate = useNavigate()
  const receipts = stock?.money_receipts || []
  const total = receipts.length ?? 0

  return (
    <Card className="border-0 shadow-sm">
      <CardBody className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="mb-0 fw-semibold">Money Receipts</h5>
          <div className="d-flex align-items-center gap-3">
            <div className="text-muted small">Total: {total}</div>
            <CanView access={[ACCESS.MONEY_RECEIPT.CREATE]}>
              <Button
                color="primary"
                size="sm"
                disabled={!stock?.id}
                onClick={() =>
                  navigate(`/money-receipts/create?vehicle_id=${stock.id}`)
                }
              >
                <i className="bx bx-plus me-1" />
                Add Money Receipt
              </Button>
            </CanView>
          </div>
        </div>
        <MoneyReceiptList data={receipts} onChanged={onChanged} />
      </CardBody>
    </Card>
  )
}
